export function isOpenInNewTabPointerEvent(event: {
  button: number
  ctrlKey: boolean
  metaKey: boolean
}): boolean {
  if(event.button === 1) {
    return true
  }
  return event.button === 0 && (event.ctrlKey || event.metaKey)
}
